export default {

    data () {
        return {
            defaultTab: 'company-info',
            activeTab: ''
        }
    },

    created () {
        this.activeTab = this.defaultTab
    },

    mounted () {
        if (window.location.hash) {
            this.loadView(window.location.hash.substring(1))
        }

        window.addEventListener('hashchange', () => {
            this.loadView(window.location.hash ? window.location.hash.substring(1) : this.defaultTab)
        })
    },

    methods: {

        loadView (name) {
            this.activeTab = name
            if (window.location.hash !== name) {
                location.href = '#' + name
            }
        }

    }
}
